import { useDrag } from 'react-use-gesture';
import React, { useRef } from 'react';

// Wrapper for gesture-enabled navigation
export const GestureNav = ({ children, onBack, onRefresh }) => {
  const isRefreshing = useRef(false);
  const isFormTarget = (event) => {
    const el = event?.target;
    if (!el) return false;
    if (el.isContentEditable) return true;
    return Boolean(el.closest && el.closest('input,select,textarea,button,label'));
  };

  const isGestureIgnored = (event) => {
    const el = event?.target;
    if (!el) return false;
    return Boolean(el.closest && el.closest('[data-gesture-ignore="true"]'));
  };

  const bind = useDrag(({ movement: [mx, my], velocity, direction: [xDir, yDir], cancel, down, event }) => {
    if (isFormTarget(event) || isGestureIgnored(event)) return;
    
    // Swipe Right to Go Back (Horizontal)
    if (mx > 100 && velocity > 0.2 && xDir > 0 && onBack) {
      cancel();
      if (!down) onBack(); // Trigger on release
    }

    // Pull Down to Refresh (Vertical) - Simple Simulation
    // Only if at top of page (window.scrollY === 0)
    if (my > 120 && velocity > 0.2 && yDir > 0 && window.scrollY <= 0 && onRefresh && !isRefreshing.current) {
      cancel();
      if (!down) {
        isRefreshing.current = true;
        onRefresh().finally(() => { isRefreshing.current = false; });
      }
    }
  }, { 
    filterTaps: true,
    axis: undefined // Detect both axes
  });

  return (
    <div {...bind()} style={{ touchAction: 'pan-y' }}> 
      {/* touchAction pan-y allows vertical scroll but captures horizontal swipes better */}
      {children}
    </div>
  );
};
